import { UUID } from "crypto";

import { JSONContent } from "@tiptap/react";

import { useDocumentStore } from "@demo/store/document";
import { useSavedDocumentContent } from "@demo/store/document-content";
import { useDocumentMetadataStore } from "@demo/store/document-metadata";
import { Role } from "@demo/types/base";
import type { DocumentInputContentItem } from "@demo/types/documentContent";
import { BLANK_WITH_MEDIA_SET_CONTAINER } from "@demo/utils/editor";

export interface UseDocumentContentReturn {
  draftContent: JSONContent;
  savedDocumentContent: DocumentInputContentItem[];
  activeDocumentUuid: UUID | null;
  isLoadingDocument: UUID | null;
}

/**
 * Hook to get document content for the editor.
 *
 * @param editorRole The role of the editor
 * @returns Document content and loading state
 */
export function useDocumentContent(editorRole: Role): UseDocumentContentReturn {
  const activeDocumentUuid = useDocumentMetadataStore((state) => state.activeDocumentUuid);
  const isLoadingDocument = useDocumentMetadataStore((state) => state.isLoadingDocument);
  const draftDocuments = useDocumentStore((state) => state.draftDocuments);
  const savedDocumentContent = useSavedDocumentContent(activeDocumentUuid, editorRole);

  let draftContent = BLANK_WITH_MEDIA_SET_CONTAINER;

  if (activeDocumentUuid) {
    draftContent = draftDocuments[activeDocumentUuid]?.[editorRole] ?? BLANK_WITH_MEDIA_SET_CONTAINER;
  }

  return {
    draftContent,
    savedDocumentContent,
    activeDocumentUuid,
    isLoadingDocument,
  };
}
